import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnGroup } from 'react-table';

import i18next from 'i18next';

import { formatDate } from 'helpers/formatDate';

import { Actions } from './components/Actions';

export const useColumns = () => {
  const { t } = useTranslation();

  return useMemo(
    (): ColumnGroup[] => [
      {
        Header: t('selection.myLists') || '',
        columns: [
          {
            Header: t('common.name')!,
            accessor: 'name',
          },
          {
            Header: t('form.insertDate')!,
            accessor: 'createdAt',
            Cell: ({ value }) => <>{formatDate(value)}</>,
          },
          {
            Header: t('common.actions') || '',
            accessor: 'id',
            Cell: ({ value, row }) => <Actions id={value} name={row.original.name} />,
          },
        ],
      },
    ],
    [i18next.language]
  );
};
